;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();export const fragment = /* GraphQL */ `
    fragment CardLocationFragment on CardLocation {
        location
        logo {
            ...Asset
        }
        address
        linkToGoogleMaps
        linkToReservation
        hoursCollection(limit: 4) {
            items {
                ... on LocationHours {
                    days
                    hours
                }
            }
        }
        descriptionLine1
        descriptionLine2
        descriptionLine3
        linkToLearnMore {
            ...EntryLink
        }
        linkToMenu {
            ...CTA
        }
        contactName
        contactEmail
        contactNumber
    }
`;
